module.exports = __webpack_public_path__ + "static/media/download.e7502976.svg";